import React, { lazy } from 'react';

const SalesBudget = lazy(() => import('./SalesBudget'));

const SalesBudgetConfig = {
    settings: {
        layout: {
            config: {}
        }
    },
    routes: [
        {
            path: '/salesBudget',
            element: <SalesBudget />
        }
    ]
};

export default SalesBudgetConfig;
